import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.telegran.site/",
});

axiosInstance.interceptors.request.use((config) => {
  const initData = window.Telegram?.WebApp?.initData;
  if (initData) {
    config.headers["X-Telegram-InitData"] = initData;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (window.Telegram?.WebApp?.showAlert) {
        window.Telegram.WebApp.showAlert(
          "Сессия истекла. Пожалуйста, перезапустите приложение."
        );
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
